import { Theme, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { CarbNutrientGroup, NutrientAmountWithFoodOrRecipes } from "shared-ui/NutrientAmount/types";
import { sumAmountsForNutrient } from "shared-ui/NutrientAmount/utils";
import NutrientTreeItem from "./NutrientTreeItem";
import { CollapseIcon, ExpandIcon, LeafIcon } from "./StyledTreeItem";
import { generateTreeStyles } from "./styles";

const useStyles = makeStyles((theme: Theme) => createStyles(generateTreeStyles(theme.palette.accents.greenLight[300], theme)));

export interface CarbohydrateTreeProps {
  carbs: CarbNutrientGroup;
  displayDri: boolean;
}

const CarbohydrateTree = ({ carbs, displayDri }: CarbohydrateTreeProps) => {
  const classes = useStyles();

  const netCarbs: NutrientAmountWithFoodOrRecipes = {
    nutrient: {
      commonName: "Net (non-fiber)",
      unitName: carbs["Total Carbs"].nutrient.unitName,
      rdiAmount: null,
      rdiType: null,
    },
    amount: Math.max(carbs["Total Carbs"].amount - carbs["Fiber"].amount, 0),
    totalFoodOrRecipesCount: carbs["Total Carbs"].totalFoodOrRecipesCount,
    reportingFoodOrRecipes: [],
    nonReportingFoodOrRecipes: [],
  };

  const totalSugars = sumAmountsForNutrient("Total Sugars", carbs["Total Sugars"], [carbs["Added Sugars"]]);

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="body2" sx={{ fontWeight: 600 }}>
        Carbohydrates
      </Typography>
      <div className={classes.content}>
        <TreeView
          className={classes.tree}
          defaultExpanded={["1"]}
          defaultCollapseIcon={<CollapseIcon />}
          defaultExpandIcon={<ExpandIcon />}
          defaultEndIcon={<LeafIcon />}
        >
          <NutrientTreeItem
            isRoot
            nodeId="1"
            nutrientAmount={carbs["Total Carbs"]}
            displayDri={displayDri}>
            <NutrientTreeItem
              nodeId="2"
              nutrientAmount={carbs["Fiber"]}
              displayDri={displayDri} />
            <NutrientTreeItem
              nodeId="3"
              nutrientAmount={netCarbs}
              displayDri={displayDri} />
            <NutrientTreeItem
              nodeId="4"
              nutrientAmount={carbs["Starch"]}
              displayDri={displayDri} />
            <NutrientTreeItem
              nodeId="5"
              nutrientAmount={totalSugars}
              displayDri={displayDri}>
              <NutrientTreeItem
                nodeId="6"
                nutrientAmount={{ ...carbs["Total Sugars"], nutrient: { ...carbs["Total Sugars"].nutrient, commonName: "Sugars" } }}
                displayDri={displayDri} />
              <NutrientTreeItem
                nodeId="7"
                nutrientAmount={carbs["Added Sugars"]}
                displayDri={displayDri} />
            </NutrientTreeItem>
          </NutrientTreeItem>
        </TreeView>
      </div>
    </div>
  );
};

export default CarbohydrateTree;
